<template>
  <div class="reason-select-box">
    <div class="sub-title">{{ title }}</div>
    <van-radio-group v-model="radio">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="reason-select-item"
        @click="select(item)"
      >
        <div>
          {{ item.value }}
        </div>
        <van-radio :name="item.key" />
      </div>
    </van-radio-group>

    <van-form
      ref="form"
      scroll-to-error
      validate-first
      :show-error-message="false"
      v-if="radio==='其他'"
    >
      <van-field
        name="rescueOpinion"
        class="textarea-box"
        v-model.trim="rescueOpinion"
        rows="3"
        autosize
        type="textarea"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="inputHandle"
        :rules="[{ required: true, message: placeholder, trigger: 'onBlur'}]"
      />
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    dataList: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请输入原因'
    },
    maxlength: {
      type: [Number, String],
      default: '500'
    }
  },
  data() {
    return {
      current: undefined,
      rescueOpinion: '',
      radio: ''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.radio = this.value;
    },
    select(item) {
      this.radio = item.key;
      this.$emit('update:value', item.key);
    },
    inputHandle(val) {
      this.$emit('update:value', val);
    },
    async validate() {
      if (!this.$refs.form) {
        return true;
      }
      try {
        await this.$refs.form.validate();
        return true;
      } catch (err) {
        console.log(err);
        Toast({
          message: err[0].message,
          position: 'bottom'
        });
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.reason-select-box{
  .sub-title{
    letter-spacing: -0.38px;

    color: #999999;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
  }
  .textarea-box{
    margin-top: 16px;
  }
  .reason-select-item {
    display: flex;
    justify-content: space-between;

    padding: 16px 0;

    letter-spacing: -0.38px;

    color: #383838;
    border-bottom: 1px solid rgba(230,230,230,1);

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    &:last-child {
      margin-bottom: -16px;

      border: none;
    }

    ::v-deep .van-radio{
      .van-radio__icon{
        font-size: 18px;
        &.van-radio__icon--checked .van-icon{
          border-color: #3399FF;
          background-color: #3399FF;
        }
        .van-icon{
          border: 1px solid rgba(153,153,153,1);
        }
      }
    }
  }
}
</style>
